/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unsafe-storage */

'use es6';

import SafeStorage from 'SafeStorage';
export default (() => next => action => {
  if (!action.meta || !action.meta.persistence) {
    return next(action);
  }
  const persistence = action.meta.persistence;
  const currentStateInLocalstorage = JSON.parse(SafeStorage.getItem(persistence.storageKey));
  SafeStorage.setItem(persistence.storageKey, JSON.stringify(persistence.mergeFunction(currentStateInLocalstorage, action.payload)));
  return next(action);
});